var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgResultSparkle2 = function SvgResultSparkle2(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 13 13"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#result-sparkle-2_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#FFF1B0",
    d: "M6.5 4C6.65 5.4 7.6 6.35 9 6.5 7.6 6.65 6.65 7.6 6.5 9 6.35 7.6 5.4 6.65 4 6.5 5.4 6.35 6.35 5.4 6.5 4"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)));
};
export default SvgResultSparkle2;